import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { trackEvent } from './utils/analytics';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  // Pre-rendered HTML exists (from react-snap) — hydrate it
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  // No pre-rendered content — normal client-side render
  ReactDOM.createRoot(rootElement).render(app);
}

// Send web vitals to Google Analytics
reportWebVitals((metric) => {
  trackEvent('Web Vitals', metric.name, Math.round(metric.value).toString());
});
